import {
  Component,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import {filter, takeWhile} from 'rxjs/operators';



@Component({
  template: '',
})
export class BaseRoutingPageComponent implements OnInit, OnDestroy {

  NavigationEvent: any = NavigationEnd;

  protected isPageActive: boolean = true;

  constructor(
    protected router: Router,
  ) {
    this.router.events
    .pipe(
        filter(event => event instanceof this.NavigationEvent),
        takeWhile(() => this.isPageActive)
    )
    .subscribe((event: any) => {
      this.onRouteChange(event);
    });
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.isPageActive = false;
  }

  onRouteChange(event: any) {
    console.warn('onRouteChange not implemented!');
  }

}
